import React from "react";
import { Button } from "../ui/button";

// Row of toggle chips: "All" clears the selection; each other chip
// adds/removes itself from `selected`. Empty selection == "All" (no filter).
export function MultiStatusFilter({ options, selected, onChange, testId = "status-filter" }) {
  const isAll = selected.length === 0;
  const toggle = (value) => {
    if (selected.includes(value)) onChange(selected.filter((v) => v !== value));
    else onChange([...selected, value]);
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      <Button
        type="button" size="sm" variant={isAll ? "default" : "outline"}
        onClick={() => onChange([])}
        data-testid={`${testId}-chip-all`}
      >
        All
      </Button>
      {options.map((opt) => (
        <Button
          key={opt.value} type="button" size="sm"
          variant={selected.includes(opt.value) ? "default" : "outline"}
          onClick={() => toggle(opt.value)}
          data-testid={`${testId}-chip-${opt.value}`}
        >
          {opt.label}
        </Button>
      ))}
    </div>
  );
}
